/** @jsx dom */
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import {Cell, Grid} from 'viskan-deku-grid';

const propTypes = {
	data: {
		type: 'object'
	},
	getPrice: {
		source: 'getPrice'
	},
	isPerson: {
		source: 'isPerson'
	}
};
const getRow = (value, label) => {
	return (
		<Grid>
			<Cell size='4of6'>
				<div class='u-textLeft'>
					<strong>{label}</strong>
				</div>
			</Cell>
			<Cell size='2of6'>
				<div class='u-textRight'>
					{value}
				</div>
			</Cell>
		</Grid>
	);
};

const shouldUpdate = ({props}, nextProps) => !deepEqual(props, nextProps);

const render = ({props}) => {
	const {data, isPerson, getPrice, getTranslation} = props;
	const {head, rows} = data;
	const {charge, total_discount, total_discount_exvat, tot_to_pay, tot_to_pay_exvat, tot_vat, wdel_carriage, wdel_carriage_exvat, wpay_carriage, wpay_carriage_exvat} = head;
	const person_flg = isPerson();

	if (rows.length === 0) {
		return (
			<div class='ShopcartSummary u-textCenter'>
				{getTranslation('shopcart.empty')}
			</div>
		);
	}

	return (
		<div class='ShopcartSummary-container'>
			{Boolean(total_discount) && getRow(getPrice(total_discount, total_discount_exvat), getTranslation('shopcart.total_discount'))}
			{Boolean(wdel_carriage) && getRow(getPrice(wdel_carriage, wdel_carriage_exvat), getTranslation('shopcart.shipping_carriage'))}
			{Boolean(wpay_carriage) && getRow(getPrice(wpay_carriage, wpay_carriage_exvat), getTranslation('shopcart.payment_carriage'))}
			{Boolean(charge) && getRow(getPrice(charge), getTranslation('shopcart.charge'))}
			{!person_flg && getRow(getPrice(tot_vat), getTranslation('shopcart.vat'))}
			{person_flg && getRow(getPrice(tot_to_pay, tot_to_pay_exvat), getTranslation('checkout.total'))}
			{!person_flg && getRow(getPrice(tot_to_pay), getTranslation('shopcart.total_incvat'))}
		</div>
	);
};

export default {propTypes, render, shouldUpdate};
